import type {FC} from 'react';

import type {MultipleChoiceAnswerModel} from '../../../../../../../core/domain/Answer/MultipleChoiceAnswer/MultipleChoiceAnswer.model';
import type {ChoiceQuestionModel} from '../../../../../../../core/domain/Question/ChoiceQuestion/ChoiceQuestion.model';
import type {QuestionProps} from '../types';

import {MultipleChoiceAnswerFactory} from '../../../../../../../core/domain/Answer/MultipleChoiceAnswer/MultipleChoiceAnswer.factory';
import {useInjection} from '../../../../../../../IoC';
import {Checkbox} from '../../../../../../../uikit/Checkbox';
import {Text} from '../../../../../../../uikit/Text';
import {platform} from '../../../../../../../utils/platform';
import * as S from './styles';

export const MultipleChoiceQuestion: FC<
  QuestionProps<ChoiceQuestionModel, MultipleChoiceAnswerModel>
> = ({answer, onAnswerChange, question}) => {
  const answerFactory = useInjection(MultipleChoiceAnswerFactory);

  const onOptionClick = (optionId: string, isSelected: boolean) => {
    onAnswerChange?.(
      answerFactory.create({
        question,
        value: isSelected ? optionId : null,
      }),
    );
  };

  return (
    <S.Container>
      {question.options.map(option => {
        const isSelected = answer?.value === option.id;

        return (
          <S.Option
            key={option.id}
            onClick={() => onOptionClick(option.id, !isSelected)}
          >
            <Checkbox
              checked={isSelected}
              onClick={
                platform.isNative
                  ? () => onOptionClick(option.id, !isSelected)
                  : undefined
              }
              variant="circle"
            />
            <Text>{option.title}</Text>
          </S.Option>
        );
      })}
    </S.Container>
  );
};
